module.exports = __webpack_public_path__ + "static/media/navbar_favorite--active.8d3441f4.svg";